import React, { Component } from 'react';
import { Row, Col, Input, Icon, Form, Button } from 'antd';
import { CaptchaForm } from '@bit/ui-common.ui-components/ss-components';

export default class ResetPasswordRequestSuccess extends Component {
    state = {
        successButtonType: 'default',
        failureButtonType: 'default',
        idFormProps: {
            required: true,
            label: (
                <div style={{ display: 'inline-block' }}>
                    {'User ID or Email'}
                </div>
            )
        }
    }

    constructor(props) { super(props); }

    toggleButtonType = button => this.setState({...this.state, [button]: this.state[button] === 'default' ? 'primary' : 'default'});

    render() {
        const
        { idFormProps } = this.state,
        { state, services, handleDisplay } = this.props,
        { request, emailId } = state.passwordReset;

        switch(request.status) {
            default: return (
                <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '10px' }}>
                    <Col span={13}>
                        <Row type='flex' justify='space-around' align='middle'>
                            <Col>
                                <Form.Item {...idFormProps} style={{ width: '241px' }}>
                                    <Input
                                        size='small'
                                        placeholder='Enter User ID or Email address'
                                        prefix={<Icon type='user' style={{ color: 'rgba(0, 0, 0, .50)' }} />}
                                        onChange={e => services.updateResetField('emailId', e.target.value)}
                                        value={emailId}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row type='flex' justify='space-around' align='middle'>
                            <Col>
                                <CaptchaForm services={services} state={state.captcha} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            );

            case 'success': return (
                <div>
                    <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '7px' }}>
                        <Col>
                            <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '15px' }}>
                                <Col>
                                    <Icon type='mail' style={{ fontSize: '50px' }} />
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '6px' }}>
                                <Col>
                                    <div style={{ fontSize: '20px', fontWeight: 'bold', fontStyle: 'italic' }}>
                                        {'Email has been sent.'}
                                    </div>
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '30px' }}>
                                <Col>
                                    <div style={{ fontSize: '12px', fontStyle: 'italic' }}>
                                        {'Please check your email for instructions to reset your password.'}
                                    </div>
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-around' align='middle'>
                                <Col>
                                    <Button
                                        size='small'
                                        icon='check-circle-o'
                                        type={this.state.successButtonType}
                                        style={{ width: '210px', borderRadius: '40px' }}
                                        onMouseOver={() => this.toggleButtonType('successButtonType')}
                                        onMouseOut={() => this.toggleButtonType('successButtonType')}
                                        onClick={() => {
                                            handleDisplay();
                                            setTimeout(function() {
                                                services.resetCaptchaValidation();
                                                services.clearResetField('emailId');
                                                services.clearRequestPasswordReset();
                                            }, 1000);
                                        }}
                                    >{'Ok'}
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            );

            case 'failure': return (
                <div>
                    <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '7px' }}>
                        <Col>
                            <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '15px' }}>
                                <Col>
                                    <Icon type='close-circle-o' style={{ fontSize: '50px' }} />
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '6px' }}>
                                <Col>
                                    <div style={{ fontSize: '20px', fontWeight: 'bold', fontStyle: 'italic' }}>
                                        {'Unable to reset password.'}
                                    </div>
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '30px' }}>
                                <Col>
                                    <div style={{ fontSize: '12px', fontStyle: 'italic' }}>
                                        {'For further assistance please contact the FTSP Help Desk.'}
                                    </div>
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-around' align='middle'>
                                <Col>
                                    <Button
                                        size='small'
                                        icon='check-circle-o'
                                        type={this.state.failureButtonType}
                                        style={{ width: '210px', borderRadius: '40px' }}
                                        onMouseOver={() => this.toggleButtonType('failureButtonType')}
                                        onMouseOut={() => this.toggleButtonType('failureButtonType')}
                                        onClick={() => {
                                            handleDisplay();
                                            setTimeout(function() {
                                                services.resetCaptchaValidation();
                                                services.clearResetField('emailId');
                                                services.clearRequestPasswordReset();
                                            }, 1000);
                                        }}
                                    >{'Ok'}
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            );
        }
    }
}
